import PersonalNav from './components/PersonalNav'
import PersonalHero from './components/PersonalHero'
import InteractiveSkills from './components/InteractiveSkills'
import EnhancedMyWork from './components/EnhancedMyWork'
import ContactForm from './components/ContactForm'

function App() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--bg-deep)' }}>
      <PersonalNav />
      <main>
        <div id="home">
          <PersonalHero />
        </div>
        <div id="about">
          <InteractiveSkills />
        </div>
        <div id="work">
          <EnhancedMyWork />
        </div>
        <div id="contact">
          <ContactForm />
        </div>
      </main>
    </div>
  )
}

export default App
